var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "value": _vm.dialog,
      "max-width": "1000",
      "persistent": ""
    }
  }, [_c('v-card', {
    attrs: {
      "disabled": _vm.loading
    }
  }, [_c('v-card-title', {
    staticClass: "headline accent--text pb-4"
  }, [_vm._v(" Личные данные ")]), _c('v-card-text', {
    staticClass: "border-top pt-6 pb-0",
    attrs: {
      "outlined": "",
      "tile": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.dictionaries.gender,
      "item-text": "name",
      "placeholder": "Выберите данные",
      "no-data-text": "Не найдено",
      "clearable": "",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "return-object": "",
      "error-messages": _vm.$errorMessages(_vm.$v.localPersonalData.gender)
    },
    on: {
      "input": function input($event) {
        return _vm.$v.localPersonalData.gender.$touch();
      },
      "blur": function blur($event) {
        return _vm.$v.localPersonalData.gender.$touch();
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "required"
        }, [_vm._v("Пол")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.localPersonalData.gender,
      callback: function callback($$v) {
        _vm.$set(_vm.localPersonalData, "gender", $$v);
      },
      expression: "localPersonalData.gender"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('PersonalNameComponent', {
    attrs: {
      "personal-name": _vm.localPersonalName
    },
    on: {
      "set-personal-name": _vm.setPersonalName
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('PersonalContactComponent', {
    attrs: {
      "personal-contact": _vm.localPersonalContact
    },
    on: {
      "set-personal-contact": _vm.setPersonalContact
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('AddressGarComponent', {
    attrs: {
      "address-gar-parent": _vm.localAddressGarParent
    },
    on: {
      "set-address-gar-parent": _vm.setAddressGarParent
    }
  })], 1)], 1)], 1), _c('v-card-actions', {
    staticClass: "px-6"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "lightGrey",
      "disabled": !_vm.personalData.id
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(" Отмена ")]), _c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "disabled": _vm.$v.$invalid || !_vm.localAddressGarParent.list.length,
      "color": "success",
      "text": ""
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v(" Сохранить ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }